import React, { useState } from 'react';
import AppIconButton from './AppIconButton';
import AppTextField from './AppTextField';

const AppPasswordField = ({
    className = '',
    disabled = false,
    showTitle = 'Mostrar clave',
    hideTitle = 'Ocultar clave',
    ...rest
}) => {
    const [visible, setVisible] = useState(false);
    const title = visible ? hideTitle : showTitle;

    return (
        <div className="fk-password-wrap">
            <AppTextField
                {...rest}
                type={visible ? 'text' : 'password'}
                disabled={disabled}
                className={['fk-password-field', className].filter(Boolean).join(' ')}
            />
            <AppIconButton
                icon={visible ? 'pi pi-eye-slash' : 'pi pi-eye'}
                title={title}
                aria-label={title}
                disabled={disabled}
                className="fk-password-toggle"
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => setVisible((current) => !current)}
            />
        </div>
    );
};

export default AppPasswordField;
